<img *ngIf="!isTestBankConnector" [src]="currentBank.logo" alt="current bank logo" class="w-78px">
<img *ngIf="isTestBankConnector" src="/assets/images/test_bank_connector.png" alt="test bank connector logo" class="w-78px">

<h1 *ngIf="count>1" class="my-8 font-20 font-md-24">{{ 'connect_accounts_several_title' | translate }}</h1>
<h1 *ngIf="count<=1" class="my-8 font-20 font-md-24">{{ 'connect_accounts_title' | translate }}</h1>

<app-lottie-loader [height]="'50px'" color="'GREEN"></app-lottie-loader>

<p class="font-16 font-md-18 font-medium italic text-center">
  <span *ngIf="count>1">{{ 'connect_accounts_several_msg1' | translate }}</span>
  <span *ngIf="count<=1">{{ 'connect_accounts_msg1' | translate }}</span>
  <br class="d-none d-md-inline"/>
  {{ 'connect_accounts_msg2' | translate }}
</p>
